<template>
    <div class="investment-tab w-100">
        <p class="my-md ml-sm">{{ description }}</p>
        <ProductInvestmentBreakdown
            class="mt-md"
            :quick-filter="quickFilter"
            :selected-watchlist="selectedWatchlist"
        />
    </div>
</template>

<script setup>
import ProductInvestmentBreakdown from '@/components/alignmentOutput/techAreas/ProductInvestmentBreakdown.vue'
import { useEntityStore } from '@/stores'
import { computed } from 'vue'
const entityStore = useEntityStore()

const props = defineProps({
    quickFilter: {
        type: String,
        default: 'all',
    },
    selectedWatchlist: {
        type: Number,
        default: null,
    },
})

const description = computed(() => {
    return `View the investment landscape over ${entityStore.entity.name}'s technology space for the past four years.`
})
</script>
